import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './core/services/language.service';
import { ServiceWorkerRegister } from './core/service-worker/serviceWorker';

@Component({
  selector: 'mega-store-vendor-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Store Vendor';
  constructor(private languageService: LanguageService,
    translate: TranslateService,
    private serviceWorker: ServiceWorkerRegister) {
    this.languageService.initialize();
  }

  ngOnInit(): void {
    this.serviceWorker.publicApi();
  }
}
